import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createNotification } from "../../services/notification";
import { IIndicators } from "../../types";
import { toast } from "react-toastify";

const useCreateNotification = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createNotification,

        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },

        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ['notifications'] });
                indicators.setIsProcessRunning(false);
                toast.success('Notification created successfully')
            }
        },

        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            toast.error(error.response?.data?.message);
            indicators.setIsServiceError(error.response?.data?.message);
        }
    });
};

export default useCreateNotification;